// @flow

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';
import {
  getCurrentPaymentMethodOptionalFields,
  hasOptionalField,
} from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';
import { shouldDisabledCustomerNameField } from '@tectonics/prs/ui/get-disabled-customer-name-field';
import { validateIndonesianCustomerName } from '@tectonics/prs/indonesia/validation/indonesian-customer-name';
import { validateIndonesianCustomerEmail } from '@tectonics/prs/indonesia/validation/indonesian-customer-email';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  const optionalFields = incomingPayment.status === 'OP'
    ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec)
    : [];
  // A readonly name comes from the merchant and cannot be fixed by the customer.
  const isReadonlyCustomerName = incomingPayment.status === 'OP'
    && shouldDisabledCustomerNameField(incomingPayment);

  switch (userInputName) {
    case 'selectedVirtualAccountBank':
      return onlyWhen('display_virtual_account_bank_list') && validateVirtualAccountBank(userInputValue);

    case 'customerName':
      if (hasOptionalField(optionalFields, 'name') || isReadonlyCustomerName) {
        return VALID;
      }
      return onlyWhen('field_indonesian_customer_name') && validateIndonesianCustomerName(userInputValue);

    case 'customerEmail':
      if (hasOptionalField(optionalFields, 'email')) {
        return VALID;
      }
      return onlyWhen('field_indonesian_customer_email') && validateIndonesianCustomerEmail(userInputValue);

    default:
      return VALID;
  }
}

function validateVirtualAccountBank(bankCode?: string): ?UserInputValidationError {
  if (!bankCode || bankCode.trim() === '')
    return { id: 'empty' };

  return VALID;
}
